module.exports = __webpack_public_path__ + "img/guide_02.c0a757ed.png";